export enum Token {
  TBTC = "TBTC",
}

export enum CoingeckoID {
  TBTC = "tbtc",
}
